import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createHead } from '@vueuse/head';
import tippy from 'tippy.js';
import i18n from './i18n';
import { createPinia } from 'pinia';

import '@unocss/reset/tailwind.css';
import 'uno.css';
import './index.scss';

import LogRocket from 'logrocket';
import * as Sentry from '@sentry/vue';
import.meta.env.VITE_LOGROCKET_APP_ID && LogRocket.init(import.meta.env.VITE_LOGROCKET_APP_ID);

const head = createHead({
    titleTemplate: '%s - House Care Admin',
});

const pinia = createPinia();
const app = createApp(App);

import.meta.env.VITE_SENTRY_DSN &&
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration({ maskAllText: false, maskAllInputs: false })],
        tracesSampleRate: 1.0,
        tracePropagationTargets: ['localhost', /^https:\/\/([a-z]+\.)*housecareonline\.in\/api/],
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 1.0,
    });

app.use(pinia);
app.use(router);
app.use(head);
app.use(i18n);

app.directive('tooltip', (el: Element, binding) => {
    if ((el as any)._tippy) (el as any)._tippy.destroy();

    if (binding.value) el.setAttribute('title', binding.value);

    el.setAttribute('data-tippy-content', el.getAttribute('title') || '');
    tippy(el, {
        onShow(instance) {
            const ref = instance.reference;
            ref.setAttribute('data-title', ref.getAttribute('title') || '');
            ref.removeAttribute('title');
        },
        onHidden(instance) {
            const ref = instance.reference;
            ref.setAttribute('title', ref.getAttribute('data-title') || '');
            ref.removeAttribute('data-title');
        },
    });
});
app.directive('truncate', (el, binding) => {
    if (el._tippy) el._tippy.destroy();
    if (el.offsetWidth < el.scrollWidth) {
        el.setAttribute('data-tippy-content', binding.value || '');
        tippy(el);
    }
});

app.mount('#app');

// Initiate service worker
if ('serviceWorker' in navigator && location.host.includes('housecareonline.in')) {
    // function skipWaiting(registration: ServiceWorkerRegistration) {
    //     setTimeout(() => {
    //         registration.waiting?.postMessage('SKIP_WAITING');
    //     }, 1000);
    // }

    window.addEventListener('load', async () => {
        try {
            let registration = await navigator.serviceWorker.register('/sw.js');

            if (registration.waiting) {
                // blockUi();
                // skipWaiting(registration);
            }

            registration.addEventListener('updatefound', () => {
                // blockUi();
                if (registration.installing) {
                    registration.installing.addEventListener('statechange', () => {
                        if (registration.waiting) {
                            if (navigator.serviceWorker.controller) {
                                // skipWaiting(registration);
                            }
                        }
                    });
                }
            });

            let refreshing = false;
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                console.log('[service worker] controller changed');
                if (!refreshing) {
                    window.location.reload();
                    refreshing = true;
                }
            });

            registration.update();
        } catch (e) {
            console.error(e);
        }
    });
}
